import { useCallback, useContext } from "react";
import { JupiterTokenContext } from "../components/jupiter-http-provider";

const addTokenToInit = (init?: RequestInit, token?: string): RequestInit | undefined => {
  if (!token) {
    return init;
  }

  const authHeaders: Record<string, string> = {};

  if (/^_CY:.+$/.test(token)) {
    authHeaders["X-CY-User"] = token.substring(4);
  } else {
    authHeaders["Authorization"] = `Bearer ${token}`;
  }

  let headers: HeadersInit | undefined;

  if (!init?.headers) {
    headers = authHeaders;
  } else if (init.headers instanceof Headers) {
    const tmpHeaders: [string, string][] = [];
    init.headers.forEach((v, k) => {
      tmpHeaders.push([k, v]);
    });
    tmpHeaders.push(...Object.entries(authHeaders));
    headers = tmpHeaders;
  } else if (Array.isArray(init.headers)) {
    const tmpHeaders: [string, string][] = [];
    init.headers.forEach(([k, v]) => {
      tmpHeaders.push([k, v]);
    });
    tmpHeaders.push(...Object.entries(authHeaders));
    headers = tmpHeaders;
  } else {
    headers = { ...init.headers, ...authHeaders };
  }

  return { ...init, headers };
};

export type FetchFn = (input: RequestInfo, init?: RequestInit) => Promise<Response>;
const fetchAvailable = typeof global.window?.fetch === "function";
const fetchFn: FetchFn = fetchAvailable ? global.window.fetch : () => Promise.reject(new Error("Fetch unavailable"));

export const useCustomFetch = (): FetchFn | undefined => {
  const { token, apiEndpoint } = useContext(JupiterTokenContext);

  const customFetch = useCallback(
    (input: RequestInfo, init?: RequestInit): Promise<Response> =>
      fetchFn(typeof input === "string" ? `${apiEndpoint}${input}` : input, addTokenToInit(init, token)),
    [token, apiEndpoint],
  );

  return token && fetchAvailable
    ? customFetch
    : undefined;
}
